<template>
    <div class="list-users-page">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">Manage hotels</h6>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <div class="card">
                        <!--
                        <div class="border-0 card-header">
                            <h3 class="mb-0">Light table</h3>
                        </div>
                        -->
                        <div class="card-body">
                            <base-button
                                type="primary"
                                class="mb-4"
                                @click="openEditor">
                                <i class="ai ai-plus"></i>
                                Create new hotel
                            </base-button>

                            <el-popover
                                placement="left"
                                title="Filter hotels"
                                class="float-right"
                                popper-class="users-table-filter"
                                width="400"
                                trigger="click">
                                <base-button slot="reference" type="primary" outline class="filter-btn">
                                    <i class="m-0 ai ai-filter"></i>
                                    <i class="m-0 ai ai-angle-down"></i>
                                </base-button>
                                <el-form border :model="filter" label-width="130px">
                                    <el-form-item label="Name">
                                        <el-input v-model="filter.name"></el-input>
                                    </el-form-item>

                                    <el-form-item label="Short name">
                                        <el-input v-model="filter.shortName"></el-input>
                                    </el-form-item>

                                    <el-form-item label="Company name">
                                        <el-input v-model="filter.companyName"></el-input>
                                    </el-form-item>

                                    <el-form-item label="Hotel group">
                                        <el-select v-model="filter.hotelGroup" placeholder=" ">
                                            <el-option label="-- All --" :value="undefined"></el-option>
                                            <el-option
                                                v-for="hg in hotelGroups"
                                                :key="hg.id"
                                                :label="hg.name"
                                                :value="hg.id"></el-option>
                                        </el-select>

                                    </el-form-item>
                                </el-form>
                            </el-popover>

                            <el-table
                                border
                                class="table-responsive table-flush"
                                header-row-class-name="thead-light"
                                :data="filteredData"
                                :empty-text="isLoadingTableData ? 'Loading...' : 'No Data'"
                                lazy>

                                <el-table-column label="ID" prop="id" width="100" sortable></el-table-column>
                                <el-table-column label="Name" prop="name" sortable></el-table-column>
                                <el-table-column label="Short Name" prop="short_name" sortable></el-table-column>
                                <el-table-column label="Company Name" prop="company_name" sortable></el-table-column>
                                <el-table-column label="Hotel group" prop="hotel_group.name" sortable></el-table-column>
                                <el-table-column
                                    label="Billingo Client Id"
                                    prop="billingo_id"
                                    sortable></el-table-column>

                                <el-table-column label="actions" class-name="actions-column" width="130px">
                                    <template v-slot="{row}">
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="Edit hotel group"
                                            placement="top">
                                            <button
                                                type="button"
                                                @click="openEditor(row)"><i class="ai ai-edit text-yellow"></i>
                                            </button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="Delete hotel group"
                                            placement="top">
                                            <button type="button" @click="deleteItemAttention(row)">
                                                <i class="ai ai-remove text-danger"></i>
                                            </button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <!--
                            <div class="card-footer py-4 d-flex justify-content-center">
                                <base-pagination v-model="currentPage"
                                                 :total="pageCount * itemsPerPage"></base-pagination>
                            </div>
                            -->
                        </div>
                    </div>
                </div>

            </div>

        </div>
        <el-dialog
            title="Warning"
            :visible.sync="showDeleteItemAttentionModal"
            width="550px"
            center>
            <div class="h2 text-center">
                Are you sure you want to delete this hotel: {{ selectedItemForDelete.name }}?
            </div>
            <div slot="footer" class="dialog-footer">
                <base-button
                    outline
                    type="secondary"
                    @click="showDeleteItemAttentionModal = false">Cancel
                </base-button>
                <base-button type="danger" @click="deleteItem">Delete</base-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="selectedItem.id ? 'Edit hotel' : 'Create a new hotel'"
            :visible.sync="showItemEditorModal"
            width="550px"
            center
            @closed="closeEditor">
            <el-form>
                <el-form-item label="Hotel name">
                    <el-input v-model="selectedItem.name"></el-input>
                </el-form-item>

                <el-form-item label="Hotel short name">
                    <el-input v-model="selectedItem.short_name"></el-input>
                </el-form-item>

                <el-form-item label="Company name">
                    <el-input v-model="selectedItem.company_name"></el-input>
                </el-form-item>

                <el-form-item label="Hotel group">
                    <el-select
                        v-model="selectedItem.hotel_group_id"
                        placeholder=" "
                        style="width:100%;"
                        @change="toggleBillingData">
                        <el-option label="-- Please select --" :value="undefined" disabled></el-option>
                        <el-option
                            v-for="hg in hotelGroups"
                            :key="hg.id"
                            :label="hg.name"
                            :value="hg.id"></el-option>
                    </el-select>
                </el-form-item>

                <div v-if="selectedItem.hotel_group && selectedItem.hotel_group.billing_by === 'hotel'">
                    <hr class="mb-2">
                    <h3>Billing data</h3>

                    <el-form-item label="Billingo Client Id">
                        <el-input v-model="selectedItem.billingo_id" type="number"></el-input>
                    </el-form-item>

                    <el-form-item label="Name">
                        <el-input v-model="selectedItem.billing_address.name"></el-input>
                    </el-form-item>

                    <el-form-item label="County">
                        <el-input v-model="selectedItem.billing_address.country"></el-input>
                    </el-form-item>

                    <el-form-item label="City">
                        <el-input v-model="selectedItem.billing_address.city"></el-input>
                    </el-form-item>

                    <el-form-item label="Postal code">
                        <el-input v-model="selectedItem.billing_address.postcode"></el-input>
                    </el-form-item>

                    <el-form-item label="Address">
                        <el-input v-model="selectedItem.billing_address.address"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <base-button outline type="danger" @click="closeEditor">Cancel</base-button>
                <base-button
                    type="success"
                    :disabled="!itemCanBeSave"
                    @click="saveItem">
                    <i class="ai ai-save"></i>
                    {{ selectedItem.id ? 'Save' : 'Add' }}
                </base-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'
    import {BaseProgress} from '@/components'
    import RandomBackgroundColor from '@/mixins/random-background-color'
    import DeleteUserMixin from '@/mixins/delete-user'
    import {
        Table,
        TableColumn,
        DropdownMenu,
        DropdownItem,
        Dropdown,
        Pagination,
        Form,
        FormItem,
        Select,
        Option,
        Dialog,
    } from 'element-ui'

    export default {
        name: 'user-list',
        mixins: [RandomBackgroundColor, DeleteUserMixin],
        components: {
            BaseProgress,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Pagination.name]: Pagination,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Select.name]: Select,
            [Option.name]: Option,
            [Dialog.name]: Dialog,
        },
        data() {
            return {
                hotels: [],
                hotelGroups: [],
                applications: [],
                // currentPage: 0,
                // itemsPerPage: 10,
                // pageCount: 0,
                isLoadingTableData: true,
                showDeleteItemAttentionModal: false,
                showItemEditorModal: false,
                selectedItem: {},
                selectedItemForDelete: {},
                filter: {},
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser'
            }),
            filteredData: {
                get() {
                    let filteredItems = [...this.hotels];
                    console.log('FILTER', this.filter);

                    // Filter by name
                    if (this.filter.name) {
                        filteredItems = filteredItems.filter(item => item.name.toLowerCase().includes(this.filter.name.toLowerCase()));
                    }

                    // Filter by short name
                    if (this.filter.shortName) {
                        filteredItems = filteredItems.filter(item => item.short_name.toLowerCase().includes(this.filter.shortName.toLowerCase()));
                    }

                    // Filter by company name
                    if (this.filter.companyName) {
                        filteredItems = filteredItems.filter(item => item.company_name.toLowerCase().includes(this.filter.companyName.toLowerCase()));
                    }

                    // Filter by hotel group
                    if (this.filter.hotelGroup) {
                        filteredItems = filteredItems.filter(item => item.hotel_group && item.hotel_group.id === this.filter.hotelGroup);
                    }

                    // this.pageCount = Math.ceil(filteredItems.length / this.itemsPerPage) || 1;

                    /* Pagination START */
                    // const from = (this.currentPage - 1) * this.itemsPerPage;
                    // const to = from + this.itemsPerPage;
                    // filteredItems = filteredItems.slice(from, to);
                    /* Pagination END */

                    console.log('FFF', filteredItems)
                    return filteredItems;
                }
            },
            itemCanBeSave() {
                return this.selectedItem.name && this.selectedItem.short_name && !isNaN(this.selectedItem.hotel_group_id);
            }
        },
        methods: {
            deleteItemAttention(hotelGroup) {
                this.showDeleteItemAttentionModal = true;
                this.selectedItemForDelete = hotelGroup;
            },
            deleteItem() {
                this.$axios.delete('/api/admin/hotels/' + this.selectedItemForDelete.id)
                    .then(res => {
                        this.hotels = this.hotels.filter(hotel => hotel.id !== this.selectedItemForDelete.id)
                        this.$notify({
                            title: 'Hotel group deleted',
                        });
                    })
                    .catch(({response}) => {
                        this.$notify({
                            title: response.data.message,
                            type: 'danger',
                        });
                    })
                    .then(() => {
                        this.showDeleteItemAttentionModal = false;
                        this.selectedUserForDelete = {};
                    })
            },
            openEditor(hotelGroup) {
                this.showItemEditorModal = true;
                hotelGroup = hotelGroup || {};
                hotelGroup.billing_address = hotelGroup.billing_address || {};
                this.selectedItem = JSON.parse(JSON.stringify(hotelGroup));
            },
            closeEditor() {
                this.showItemEditorModal = false;
                this.selectedItem = {};
            },
            saveItem() {
                if (this.selectedItem.id) {
                    this.$axios.put('/api/admin/hotels/' + this.selectedItem.id, this.selectedItem)
                        .then(res => {
                            const hotel = res.data.data;
                            const hotelIdx = this.hotels.findIndex(hg => hg.id === hotel.id);
                            this.hotels[hotelIdx] = hotel;
                            this.hotels = [...this.hotels];
                            this.$notify({
                                title: 'Hotel group has updated',
                            });
                        })
                        .catch(({response}) => {
                            this.$notify({
                                title: response.data.message,
                                type: 'danger',
                            });
                        })
                        .then(() => {
                            this.closeEditor();
                        })
                } else {
                    this.$axios.post('/api/admin/hotels', this.selectedItem)
                        .then(res => {
                            this.hotels.unshift(res.data.data);
                            this.$notify({
                                title: 'New hotel group has added',
                            });
                        })
                        .catch(({response}) => {
                            this.$notify({
                                title: response.data.message,
                                type: 'danger',
                            });
                        })
                        .then(() => {
                            this.closeEditor();
                        })

                }
            },
            toggleBillingData(newHotelGroupId) {
                this.selectedItem.hotel_group = this.hotelGroups.find(hg => hg.id === newHotelGroupId);
                this.selectedItem = {...this.selectedItem};
            }
        },
        async created() {
            this.hotels = (await this.$axios.get('/api/admin/hotels')).data.data;
            this.hotelGroups = (await this.$axios.get('/api/admin/hotel-groups')).data.data;
            this.applications = (await this.$axios.get('/api/admin/applications')).data.data;
            this.isLoadingTableData = false;
        },
    };
</script>
<style lang="scss">
    .list-users-page {
        .application-icon {
            display: inline-block;
            width: 36px;
            height: 36px;
            object-fit: cover;
            object-position: center center;
            cursor: default;

            &:not(:last-child) {
                margin-right: 5px;
            }

            &.text-icon {
                color: #fff;
                text-transform: uppercase;
                text-align: center;
                border-radius: 500px;
                line-height: 36px;
                font-size: 24px;
                vertical-align: middle;
            }
        }
    }

    .users-table-filter {
        .el-select {
            width: 100%;
        }
    }
</style>
